import { getDiaStrTurno } from "global/utils/diasTurno";
import "./CardTurnoFiltro.css";
import {
  CardBody,
  CardContainer,
  CardTitle,
  ConfirmarBtn,
  DiaContainer,
  DiaTexto,
} from "./localstyle";

const CardTurnoFiltro2 = ({
  idTurno,
  medico,
  centro,
  ubicacion,
  coordenadaGps,
  hora,
  fecha,
  handleOnClickConfirmar,
  especialidad,
  proceso,
}) => {
  return (
    <CardContainer>
      <CardTitle className="c-white rb16m">
        {proceso === "labo" ? centro : medico}
      </CardTitle>
      <CardBody $proceso={proceso}>
        <p>{especialidad}</p>
        {proceso !== "labo" && <p className="rb16xl">{centro}</p>}
        <a
          href={`https://maps.google.com/?q=${coordenadaGps}`}
          target="_blank"
          rel="noreferrer"
          className="c-latex30 rb12tl"
        >
          {ubicacion}
        </a>
        <DiaContainer>
          <DiaTexto className="rb16xl">
            <div>
              {getDiaStrTurno(fecha, false, true)}
              {getDiaStrTurno(fecha, true, true)}
            </div>
            <span className="rb16t">{`${hora}hs`}</span>
          </DiaTexto>
          <div>
            <ConfirmarBtn
              id={idTurno}
              onClick={() => handleOnClickConfirmar()}
              className="c-primary rb18m"
            >
              Confirmar
            </ConfirmarBtn>
          </div>
        </DiaContainer>
      </CardBody>
    </CardContainer>
  );
};
export default CardTurnoFiltro2;
